module.exports = __webpack_public_path__ + "img/select.2290958a.svg";